import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import Translate from '@Components/Translate';
import DataStorage from '@Helpers/DataStorage';
import IndexApp from './app/indexApp';
import {AuthProvider} from '@Services/AuthService/AuthContext';

const app = ReactDOM.createRoot(document.getElementById('app'));

DataStorage.init();

app.render(
	<Translate language={DataStorage.getData('locale') ?? 'en'}>
		<AuthProvider>
			<BrowserRouter>
				<IndexApp />
			</BrowserRouter>
		</AuthProvider>
	</Translate>
);
